export const splitDateTime = (dateTimeStr?: string) => {
  if (!dateTimeStr) {
    return { date: "-", time: "-" };
  }

  const dateObj = new Date(dateTimeStr);

  if (isNaN(dateObj.getTime())) {
    return { date: "-", time: "-" };
  }

  const date = dateObj.toISOString().split("T")[0]; // YYYY-MM-DD
  const time = dateObj.toISOString().split("T")[1].split(".")[0]; // HH:MM:SS

  return { date, time };
};
